import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { InputTextField } from 'gandi.react-form';
import useCountry from '../../../hooks/useCountry';
import CountryField from '../../CountryField';
import SubdivisionField from '../../SubdivisionField';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function AddressField({
  bu,
  change,
  countryFieldValue,
  defaultCountry,
  disabled = false,
  forceMandatorySubdivision = false,
  onChangeCountry,
  showSubdivisions
}) {
  const {
    __
  } = useTranslator();
  const {
    isMandatorySubdivision,
    isMandatoryZipCode,
    subdivisions
  } = useCountry(countryFieldValue || defaultCountry, bu);
  React.useEffect(() => {
    if (defaultCountry && !countryFieldValue) {
      change('country', defaultCountry);
    }
  }, []);
  function handleChangeCountry(evt) {
    change('streetaddr', '');
    change('streetaddr2', '');
    change('zip', '');
    change('city', '');
    change('state', '');
    if (onChangeCountry) {
      onChangeCountry(evt);
    }
  }
  const renderZipField = () => {
    const help = __('View ' + '<a href="https://en.wikipedia.org/wiki/List_of_postal_codes" target="_blank" ' + 'rel="noopener noreferrer" tabIndex="-1">List of Postal Codes</a> on Wikipedia.', {
      withHTML: true
    });
    return /*#__PURE__*/_jsx(InputTextField, {
      help: /*#__PURE__*/_jsx("span", {
        dangerouslySetInnerHTML: help
      }),
      label: __('Zip code'),
      name: "zip",
      disabled: disabled,
      required: true
    });
  };
  const shouldRenderSubdivisions = !!subdivisions.length && (forceMandatorySubdivision || isMandatorySubdivision || showSubdivisions);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CountryField, {
      defaultValue: defaultCountry,
      disabled: disabled,
      name: "country",
      onChange: handleChangeCountry,
      required: true
    }), /*#__PURE__*/_jsx(InputTextField, {
      label: __('Street and number'),
      name: "streetaddr",
      disabled: disabled,
      required: true
    }), /*#__PURE__*/_jsx(InputTextField, {
      label: __('Neighborhood, unit, building, etc.'),
      name: "streetaddr2",
      disabled: disabled
    }), countryFieldValue === 'FR' && isMandatoryZipCode && renderZipField(), /*#__PURE__*/_jsx(InputTextField, {
      label: __('City'),
      name: "city",
      disabled: disabled,
      required: true
    }), !!countryFieldValue && shouldRenderSubdivisions && /*#__PURE__*/_jsx(SubdivisionField, {
      bu: bu,
      country: countryFieldValue,
      name: "state",
      disabled: disabled,
      required: forceMandatorySubdivision || isMandatorySubdivision
    }), countryFieldValue !== 'FR' && isMandatoryZipCode && renderZipField()]
  });
}
AddressField.preFetch = function preFetch(args) {
  return Promise.all([CountryField.preFetch(args), SubdivisionField.preFetch(args)]);
};
export default AddressField;